// src/components/ArtDeck.js
import './ArtDeck.css';
import ArtCard from './ArtCard';
import { motion } from 'framer-motion';
import curatedMap from './curatedLookup';

export const artData = [
  {
    id: 'rain',
    img: '/art/rain.jpg',
    name: 'Rain Without You',
    price: '$85',
    shopify: '42314258382982',
  },
  {
    id: 'fuji',
    img: '/art/fuji.jpg',
    name: 'Fuji',
    price: '$85',
    shopify: '41867682414726',
  },
 {
    id: 'dream',
    img: '/art/dream.jpg',
    name: 'Dream',
    price: '$85',
    shopify: '41774090846342',
  },
 {
    id: 'rise',
    img: '/art/rise.jpg',
    name: 'Rise Angel',
    price: '$85',
    shopify: '41726047191174',
  },
 {
    id: 'water',
    img: '/art/water.jpg',
    name: 'This Water',
    price: '$85',
    shopify: '41725830922374',
  },
 {
    id: 'ocho',
    img: '/art/ocho.jpg',
    name: 'OCHO RIOS',
    price: '$85',
    shopify: '41725918445702',
  },
 {
    id: 'stayone',
    img: '/art/stayone.jpg',
    name: 'Stay Creative',
    price: '$85',
    shopify: '41764205363334',
  },
 {
    id: 'staytwo',
    img: '/art/staytwo.jpg',
    name: 'Stay Creative II',
    price: '$85',
    shopify: '42314252091526',
  },
 {
    id: 'panton',
    img: '/art/panton.jpg',
    name: 'Panton Clean',
    price: '$85',
    shopify: '41794369978502',
  },
 {
    id: 'aenf',
    img: '/art/aenf.jpg',
    name: 'AENF',
    price: '$85',
    shopify: '41794368209030',
  },
 {
    id: 'kyoto',
    img: '/art/kyoto.jpg',
    name: 'Kyoto',
    price: '$85',
    shopify: '41867847467142',
  },
 {
    id: 'loved',
    img: '/art/loved.jpg',
    name: 'Loved',
    price: '$85',
    shopify: '41774088093830',
  },
 {
    id: '108',
    img: '/art/108.jpg',
    name: '108',
    price: '$85',
    shopify: '41774091010182',
  },
 {
    id: 'bloomlight',
    img: '/art/bloomlight.jpg',
    name: 'Bloom (Light)',
    price: '$85',
    shopify: '41725954326662',
  },
 {
    id: 'bloomdark',
    img: '/art/bloomdark.jpg',
    name: 'Bloom (Dark)',
    price: '$85',
    shopify: '41725901078662',
  },
 {
    id: 'trapped',
    img: '/art/trapped.jpg',
    name: 'Trapped',
    price: '$85',
    shopify: '42314258710662',
  },
 {
    id: 'soul',
    img: '/art/soul.jpg',
    name: 'Soul Searching',
    price: '$85',
    shopify: '41784554750086',
  },
 {
    id: 'peace',
    img: '/art/peace.jpg',
    name: 'PEACE',
    price: '$85',
    shopify: '41784559698054',
  },
 {
    id: 'cogs',
    img: '/art/cogs.jpg',
    name: 'COGS',
    price: '$85',
    shopify: '41784556552326',
  },
 {
    id: 'floral',
    img: '/art/floral.jpg',
    name: 'FLORAL',
    price: '$85',
    shopify: '41725772071046',
  },
 {
    id: 'room',
    img: '/art/room.jpg',
    name: 'The Room',
    price: '$85',
    shopify: '41774090027142',
  },
 {
    id: 'remember',
    img: '/art/remember.jpg',
    name: 'Remember',
    price: '$85',
    shopify: '42314242031750',
  },
 {
    id: 'over',
    img: '/art/over.jpg',
    name: 'Overthought',
    price: '$85',
    shopify: '41794343534726',
  },
 {
    id: 'veil',
    img: '/art/veil.jpg',
    name: 'Veil',
    price: '$85',
    shopify: '42314254057606',
  },
 {
    id: 'lies',
    img: '/art/lies.jpg',
    name: 'Lies',
    price: '$85',
    shopify: '42018425405574',
  },
 {
    id: 'cool',
    img: '/art/cool.jpg',
    name: 'Cool Graphic',
    price: '$85',
    shopify: '41794358280326',
  },
 {
    id: 'radiant',
    img: '/art/radiant.jpg',
    name: 'RADIANT',
    price: '$85',
    shopify: '41784554946694',
  },
 {
    id: 'search',
    img: '/art/search.jpg',
    name: 'Searching for Wings',
    price: '$85',
    shopify: '42314256351366',
  },
 {
    id: 'envy',
    img: '/art/envy.jpg',
    name: 'Envy',
    price: '$85',
    shopify: '41774089175174',
  },
 {
    id: 'club',
    img: '/art/club.jpg',
    name: 'Club Festivus',
    price: '$85',
    shopify: '41726041882758',
  },
{
    id: 'moment',
    img: '/art/moment.jpg',
    name: 'In the Moment',
    price: '$85',
    shopify: '41726015930502',
  },
{
    id: 'wins',
    img: '/art/wins.jpg',
    name: 'Everybody Wins',
    price: '$85',
    shopify: '41725815619718',
  },
{
    id: 'lately',
    img: '/art/lately.jpg',
    name: 'Lately',
    price: '$85',
    shopify: '41726042865798',
  },
{
    id: 'load',
    img: '/art/load.jpg',
    name: 'Loading',
    price: '$85',
    shopify: '41726024712326',
  },
{
    id: 'flower',
    img: '/art/flower.jpg',
    name: 'Flower',
    price: '$85',
    shopify: '41867833737350',
  },
{
    id: 'expo',
    img: '/art/expo.jpg',
    name: 'Expo 70',
    price: '$85',
    shopify: '41727976996998',
  },
{
    id: 'unique',
    img: '/art/unique.jpg',
    name: 'Unique',
    price: '$85',
    shopify: '41726050861190',
  },
{
    id: 'sunup',
    img: '/art/sunup.jpg',
    name: 'Sunup',
    price: '$85',
    shopify: '41725996761222',
  },
{
    id: 'track',
    img: '/art/track.jpg',
    name: 'TRACKING',
    price: '$85',
    shopify: '41784556880006',
  },
{
    id: 'stump',
    img: '/art/stump.jpg',
    name: 'STUMPED',
    price: '$85',
    shopify: '41794363392134',
  },
{
    id: 'warum',
    img: '/art/warum.jpg',
    name: 'WARUM',
    price: '$85',
    shopify: '41725916250246',
  },
{
    id: 'mule',
    img: '/art/mule.jpg',
    name: 'Mule Musiq',
    price: '$85',
    shopify: '41765733302406',
  },
{
    id: 'idea',
    img: '/art/idea.jpg',
    name: 'Idea',
    price: '$85',
    shopify: '41726001021062',
  },
{
    id: 'work',
    img: '/art/work.jpg',
    name: 'Workspace',
    price: '$85',
    shopify: '41725990502534',
  },
{
    id: 'sheriff',
    img: '/art/sheriff.jpg',
    name: 'The Sheriffs Showdown',
    price: '$85',
    shopify: '41764233937030',
  },
{
    id: 'united',
    img: '/art/united.jpg',
    name: 'United We Dance',
    price: '$85',
    shopify: '41726052270214',
  },
{
    id: 'window',
    img: '/art/window.jpg',
    name: 'Your Window',
    price: '$85',
    shopify: '41774089666694',
  },
{
    id: 'fear',
    img: '/art/fear.jpg',
    name: 'FEAR',
    price: '$85',
    shopify: '42021179785350',
  },
{
    id: 'void',
    img: '/art/void.jpg',
    name: 'VOID',
    price: '$85',
    shopify: '41774090485894',
  },
{
    id: 'dirty',
    img: '/art/dirty.jpg',
    name: 'DIRTY MIND',
    price: '$85',
    shopify: '41774091501702',
  },
{
    id: 'trigger',
    img: '/art/trigger.jpg',
    name: 'The Trigger',
    price: '$85',
    shopify: '41774088618118',
  },
{
    id: 'qualm',
    img: '/art/qualm.jpg',
    name: 'Qualm',
    price: '$85',
    shopify: '41725983883398',
  },
{
    id: 'dozzy',
    img: '/art/dozzy.jpg',
    name: 'Dozzy',
    price: '$85',
    shopify: '41725795139718',
  },
{
    id: 'tour',
    img: '/art/tour.jpg',
    name: 'Chromakopia World Tour',
    price: '$85',
    shopify: '41784554487942',
  },
{
    id: 'objekt',
    img: '/art/objekt.jpg',
    name: 'Object All Day',
    price: '$85',
    shopify: '41726016258182',
  },
{
    id: 'bunk',
    img: '/art/bunk.jpg',
    name: 'BUNKER',
    price: '$85',
    shopify: '41725905535110',
  },
{
    id: 'rave',
    img: '/art/rave.jpg',
    name: 'Rave',
    price: '$85',
    shopify: '41725900521606',
  },
{
    id: 'disco',
    img: '/art/disco.jpg',
    name: 'De La Disco',
    price: '$85',
    shopify: '41725880336518',
  },
{
    id: 'sad',
    img: '/art/sad.jpg',
    name: 'Sad and Unproductive',
    price: '$85',
    shopify: '41725875748998',
  },
{
    id: 'times',
    img: '/art/times.jpg',
    name: 'endoftimes',
    price: '$85',
    shopify: '41725917528198',
  },
{
    id: 'spiked',
    img: '/art/spiked.jpg',
    name: 'Spiked',
    price: '$85',
    shopify: '41784555602054',
  },
{
    id: 'hypno',
    img: '/art/hypno.jpg',
    name: 'Hypnosis',
    price: '$85',
    shopify: '41725846487174',
  },
{
    id: 'oxford',
    img: '/art/oxford.jpg',
    name: 'Oxford',
    price: '$85',
    shopify: '41725854318726',
  },
{
    id: 'dvs1',
    img: '/art/dvs1.jpg',
    name: 'DVS1',
    price: '$85',
    shopify: '41725776134278',
  },
{
    id: 'brain',
    img: '/art/brain.jpg',
    name: 'High Speed Brain',
    price: '$85',
    shopify: '41725764239494',
  },
{
    id: 'replay',
    img: '/art/replay.jpg',
    name: 'REPLAY',
    price: '$85',
    shopify: '41725763747974',
  },
{
    id: 'odyssey',
    img: '/art/odyssey.jpg',
    name: 'ODYSSEY',
    price: '$85',
    shopify: '41725758898310',
  },
{
    id: 'mutar',
    img: '/art/mutar.jpg',
    name: 'Mutar',
    price: '$85',
    shopify: '41725958652038',
  },
{
    id: 'look',
    img: '/art/look.jpg',
    name: 'Look Out',
    price: '$85',
    shopify: '41726056169606',
  },
{
    id: 'every',
    img: '/art/every.jpg',
    name: 'Everything',
    price: '$85',
    shopify: '41725970284678',
  },
{
    id: 'dopa',
    img: '/art/dopa.jpg',
    name: 'DOPAMINE',
    price: '$85',
    shopify: '41725977985158',
  },
];

const CARD_WIDTH_VW = 9;
const CARD_ASPECT_RATIO = 3 / 4;
const CARD_GAP_VW = 0.8;

// Animate cards individually (staggered)
const cardVariants = {
  initial: { opacity: 0, y: 20 },
  animate: (index) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: index * 0.1,
      duration: 0.3,
      ease: 'easeOut',
    },
  }),
  exit: (index) => ({
    opacity: 0,
    y: -20,
    transition: {
      delay: (6 - index) * 0.05, // reverse order exit
      duration: 0.2,
      ease: 'easeIn',
    },
  }),
};

// Animate the wrapper container (for staggered children)
const containerVariants = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.1,
    },
  },
  exit: {},
};

export const scaledHeight = `calc(${CARD_WIDTH_VW}vw * ${1 / CARD_ASPECT_RATIO})`;

export default function ArtDeck({ deck }) {
  return (
    <motion.div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: `${CARD_GAP_VW}vw`,
        height: scaledHeight,
        padding: 0,
        margin: 0,
      }}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={containerVariants}
    >
      {deck.map((art, index) => (
        <motion.div
          key={art.id}
          custom={index}
          variants={cardVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          style={{
            width: `${CARD_WIDTH_VW}vw`,
            aspectRatio: `${CARD_ASPECT_RATIO}`,
            flexShrink: 0,
          }}
        >
          <ArtCard art={art} />
        </motion.div>
      ))}
    </motion.div>
  );
}